import { BASE_URL_V2 } from 'constants/api';

import { stringify } from 'query-string';

import actions from './index';

export const ACTIONS = {
  GET: 'CURRICULUM_HOME_GET',
  GET_SUCCESS: 'CURRICULUM_HOME_GET_SUCCESS',
  GET_FAILURE: 'CURRICULUM_HOME_GET_FAILURE',
  INVALIDATE_ITEM: 'CURRICULUM_HOME_INVALIDATE_ITEM',
};

export const get = actions.get(
  (studentId, query = {}) =>
    `${BASE_URL_V2}/students/${studentId}/curriculum-home/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const invalidateItem = (id, query) => ({
  type: ACTIONS.INVALIDATE_ITEM,
  payload: {
    id,
    query,
  },
});
